import React, { useState } from "react";
import PageHero from "../components/PageHero";
import { Phone, Mail, MapPin, Clock, CheckCircle2 } from "lucide-react";
import { api } from "../lib/api";
import { COMPANY } from "../lib/constants";
import { toast } from "sonner";
import WhatsAppIcon from "../components/WhatsAppIcon";

export default function Contact() {
  const [form, setForm] = useState({ name: "", phone: "", email: "", subject: "", message: "" });
  const [done, setDone] = useState(false);
  const [busy, setBusy] = useState(false);
  const update = (k, v) => setForm((f) => ({ ...f, [k]: v }));

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      const payload = { ...form };
      if (!payload.email) delete payload.email;
      await api.post("/contact", payload);
      setDone(true);
      toast.success("Message sent");
    } catch (e) {
      toast.error("Failed to send. Please try again.");
    } finally {
      setBusy(false);
    }
  };

  return (
    <div>
      <PageHero kicker="Contact" title="Talk to Melopa Invents" description="For tenders, bulk supply, institutional procurement or infrastructure projects." />
      <section className="section">
        <div className="container-x grid lg:grid-cols-3 gap-8">
          <div className="lg:col-span-2 card-premium p-6">
            {done ? (
              <div className="text-center py-8">
                <CheckCircle2 className="w-12 h-12 text-[var(--melopa-green)] mx-auto" />
                <h3 className="text-2xl font-bold text-navy mt-2">Thank you</h3>
                <p className="text-[var(--melopa-muted)]">We have received your message and will revert shortly.</p>
              </div>
            ) : (
              <form onSubmit={submit} className="grid gap-4 sm:grid-cols-2" data-testid="contact-form">
                <div>
                  <label className="label">Full Name *</label>
                  <input className="input" required value={form.name} onChange={(e) => update("name", e.target.value)} data-testid="contact-name" />
                </div>
                <div>
                  <label className="label">Phone</label>
                  <input className="input" value={form.phone} onChange={(e) => update("phone", e.target.value)} />
                </div>
                <div className="sm:col-span-2">
                  <label className="label">Email</label>
                  <input className="input" type="email" value={form.email} onChange={(e) => update("email", e.target.value)} />
                </div>
                <div className="sm:col-span-2">
                  <label className="label">Subject</label>
                  <input className="input" value={form.subject} onChange={(e) => update("subject", e.target.value)} />
                </div>
                <div className="sm:col-span-2">
                  <label className="label">Message *</label>
                  <textarea className="input" rows={5} required value={form.message} onChange={(e) => update("message", e.target.value)} data-testid="contact-message" />
                </div>
                <div className="sm:col-span-2">
                  <button disabled={busy} className="btn-primary" data-testid="contact-submit">{busy ? "Sending…" : "Send Message"}</button>
                </div>
              </form>
            )}
          </div>
          <aside className="space-y-3">
            <div className="card-premium p-5">
              <div className="flex items-center gap-3"><Phone className="w-5 h-5 text-navy" /><div><div className="text-xs text-[var(--melopa-muted)]">Phone</div><a className="font-semibold text-navy" href={`tel:${COMPANY.phone.replace(/\s+/g, "")}`}>{COMPANY.phone}</a></div></div>
            </div>
            <div className="card-premium p-5">
              <div className="flex items-center gap-3"><WhatsAppIcon className="w-5 h-5 text-[var(--melopa-green)]" /><div><div className="text-xs text-[var(--melopa-muted)]">WhatsApp</div><a className="font-semibold text-navy" target="_blank" rel="noreferrer" href={`https://wa.me/${COMPANY.whatsapp}`}>Chat with us</a></div></div>
            </div>
            <div className="card-premium p-5">
              <div className="flex items-center gap-3"><Mail className="w-5 h-5 text-[var(--melopa-saffron)]" /><div><div className="text-xs text-[var(--melopa-muted)]">Email</div><a className="font-semibold text-navy" href={`mailto:${COMPANY.email}`}>{COMPANY.email}</a></div></div>
            </div>
            <div className="card-premium p-5">
              <div className="flex items-center gap-3"><MapPin className="w-5 h-5 text-navy" /><div><div className="text-xs text-[var(--melopa-muted)]">Address</div><div className="font-semibold text-navy">{COMPANY.address}</div></div></div>
            </div>
            <div className="card-premium p-5">
              <div className="flex items-center gap-3"><Clock className="w-5 h-5 text-navy" /><div><div className="text-xs text-[var(--melopa-muted)]">Business Hours</div><div className="font-semibold text-navy">Mon–Sat, 9:30 AM – 6:30 PM</div></div></div>
            </div>
          </aside>
        </div>
      </section>
      <section className="section bg-soft">
        <div className="container-x">
          <iframe
            title="Bengaluru Map"
            className="w-full h-[360px] rounded-2xl border border-soft"
            src="https://www.google.com/maps?q=Bengaluru,Karnataka,India&output=embed"
            loading="lazy"
          />
        </div>
      </section>
    </div>
  );
}
